module.exports = __webpack_public_path__ + "img/icon_trade.c50bb69.svg";